import { Component, ViewChild } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { AbstractCellEditor, CustomCellEditorParams } from '@app/shared/components/cell-edit/abstract.cell-editor';
import { format } from '@app/shared/extra/decimal-format';

@Component({
  selector: 'text-area-cell-edit',
  templateUrl: './number-cell-edit.component.html',
  styleUrls: ['./number-cell-edit.component.scss'],
  standalone: false
})
export class NumberCellEditComponent extends AbstractCellEditor {
  public suffix?: string;

  @ViewChild(MatInput, {static: false}) public input: MatInput;

  /**
   * Prevents typing unwanted characters in a numeric field
   * @param {InputEvent} event
   * @returns {boolean}
   */
  public validateKeypressEvent(event: InputEvent): boolean {
    const input = event.data;
    const pattern = /[0-9\-.,]/;
    return event.inputType != 'insertText' || this.validateInput(input, pattern);
  }

  /**
   * Prevents pasting unwanted characters in a numeric field
   * @param {ClipboardEvent} event
   * @returns {boolean}
   */
  public validatePasteEvent(event: ClipboardEvent): boolean {
    const input = event.clipboardData.getData('text');
    const pattern = /^(?:-?\d+|-?\d{1,3}(?:\s?\d{3})+)?(?:[,.]\d+)?$/;
    return this.validateInput(input, pattern);
  }

  /**
   * Validates a string against a given pattern
   *
   * @param input The string to validate
   * @param pattern The regular expression pattern for validation
   * @return True if the string is valid, false otherwise
   */
  private validateInput(input: string, pattern: RegExp): boolean {
    return pattern.test(input);
  }

  /**
   * Initialisation method for the render component
   * @param params A merge of default cell editor params and custom params
   */
  public agInit(params: CustomCellEditorParams<number>): void {
    super.agInit(params);
    this.suffix = this.params.suffix;
  }

  /**
   *  A hook to perform any necessary operation just after the GUI for this component has been rendered on the screen.
   *  This method is called each time the edit component is activated.
   */
  public afterGuiAttached(): void {
    this.input.focus();
  }

  /**
   * Return the final value - called by the grid once after editing is complete
   */
  public getValue(): any {
    return this.control.value ? Number(format(this.control.value)) : this.control.value;
  }
}
